export default __webpack_public_path__ + "static/media/img6.50463fd4.jpeg";